const datatableStylesAlt = {
    header: {
        style: {
            backgroundColor: "#e10600",
            color: "#FFFFFF",
            fontSize: '12pt',
            minHeight: '40px',
        }
    },
    subHeader: {
        style: {
            backgroundColor: "#FFFFFF",
            color: "#000000",
            borderBottom: '1px solid #e10600',
            minHeight: '40px',
        }
    },
    headRow: {
        style: {
            backgroundColor: "#FFFFFF",
            color: '#000000',
            borderBottom: '1px solid #e10600',
            minHeight: '40px',
        }
    },
    headCells: {
        style: {
            backgroundColor: "#FFFFFF",
            paddingLeft: '8px',
            paddingRight: '8px',
        }
    },
    rows: {
        style: {
            paddingLeft: '5px',

        },
    },
    cells: {
        style: {
            paddingLeft: '8px',
            paddingRight: '8px',
        },
    }
}

export default datatableStylesAlt;